<template>
  <div>
    <div class="d-nav d-support-nav pc-nav">
      <ul class="menu-box df jcsb">
        <li
          :class="
            activeKey == item.path ? 'menu-item cp active' : 'menu-item cp'
          "
          v-for="(item, index) in menuList"
          :key="index"
          @click.stop="openLink(item)"
        >
          <div :class="activeKey == item.path ? 'bottomLine' : ''">
            {{ item.meta.title }}
          </div>

          <ul
            class="children-menu-box"
            v-if="item.children && item.children.length > 0"
          >
            <li
              :class="
                routePath === el.path
                  ? 'children-menu-item cp children-active'
                  : 'children-menu-item cp'
              "
              @click.stop="openLink(el)"
              v-for="(el, i) in item.children"
            >
              {{ el.meta.title }}
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="d-nav d-support-nav mobile-nav">
      <i class="iconfont icon-sousuo search"></i>
      <i class="iconfont icon-fenlei menu-ico" @click="showNav = true"></i>
      <div class="mobile-nav-box" v-show="showNav">
        <div class="mobile-scroll-box">
          <div class="close-menu-icon">
            <i
              class="iconfont icon-a-close1 menu-icon"
              @click="showNav = false"
            >
            </i>
          </div>
          <ul class="mobile-menu-box">
            <li
              :class="
                activeKey == item.path
                  ? 'mobile-menu-item cp active'
                  : 'mobile-menu-item cp'
              "
              v-for="(item, index) in menuList"
              :key="index"
            >
              <div
                class="mobile-menu-item-title-box"
                @click.stop="openLink(item)"
              >
                <span>{{ item.meta.title }}</span>
                <!-- icon-down icon-right-->
                <i
                  v-if="item.children.length"
                  :class="
                    item.showChildrenMenu
                      ? 'iconfont icon-down menu-icon'
                      : 'iconfont icon-right menu-icon'
                  "
                  @click.stop="showChildrenMenuFn(item)"
                >
                </i>
              </div>
              <ul
                class="mobile-children-menu-box"
                v-if="
                  item.children &&
                  item.children.length > 0 &&
                  item.showChildrenMenu
                "
              >
                <li
                  :class="
                    routePath === el.path
                      ? 'mobile-children-menu-item cp children-active'
                      : 'mobile-children-menu-item cp'
                  "
                  @click.stop="openLink(el)"
                  v-for="(el, i) in item.children"
                >
                  {{ el.meta.title }}
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import menuData from '@/utils/supportMenu'
export default {
  watch: {
    $route: {
      handler(e) {
        if (e && e.path) {
          this.routePath = e.path
        }
      },
      immediate: true,
    },
  },
  computed: {
    activeKey: function () {
      let str = ''
      this.menuList.forEach((item) => {
        if (this.routePath.includes(item.path)) {
          str = item.path
        }
      })
      return str || '/web/home'
    },
  },
  components: {},
  data() {
    return {
      routePath: '',
      menuList: [],
      showNav: false,
    }
  },
  created() {
    this.menuList = this.recursionMenu(menuData)
  },
  methods: {
    recursionMenu(arr) {
      const newArr = []
      arr.forEach((item) => {
        if (item.meta.type !== 4) {
          const obj = Object.assign(
            {
              showChildrenMenu: false,
            },
            item
          )
          if (item.children && item.children.length > 0) {
            obj.children = this.recursionMenu(item.children)
          } else {
            obj.children = []
          }
          newArr.push(obj)
        }
      })
      return newArr
    },
    openLink(v) {
      if (this.routePath && v.path === this.routePath) {
        return false
      }
      this.showNav = false
      if (v.meta && v.meta.type === 3) {
        if (v.meta.isFrame) {
          window.open(v.path, '_blank')
        } else {
          const routeData = this.$router.resolve({ path: v.path })
          window.open(routeData.href, '_blank')
        }
      } else {
        this.$router.push({ path: v.path })
      }
    },
    showChildrenMenuFn(v) {
      v.showChildrenMenu = !v.showChildrenMenu
    },
  },
}
</script>
<style scoped lang="scss">
</style>